import React from 'react';
import PropTypes from 'prop-types';
import '../../styles/scss/elements/counter-button.scss';

const CounterButton = ({ value, addCounter, subCounter }) => {
  return (
    <div
      className="u-flex counter-button__wrapper"
      aria-label="Counter"
      aria-valuemin="0"
      aria-valuemax="4"
    >
      <div className="counter-button__input">{value}</div>
      <button className="counter-button__minus" onClick={subCounter}></button>
      <button className="counter-button__add" onClick={addCounter}></button>
    </div>
  );
};

CounterButton.prototype = {
  value: PropTypes.number.isRequired,
  addCounter: PropTypes.func.isRequired,
  subCounter: PropTypes.func.isRequired,
};

export default CounterButton;
